import React from 'react';
import { Box, Heading, Text, Link } from '@chakra-ui/react';
import { useColorModeValue } from './chakra-ui/color-mode';

function IframeEmbed({ embed }) {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const borderColor = useColorModeValue('gray.200', 'gray.800');

  if (!embed || !embed.id) {
    return null;
  }

  // Construct the iframe URL from ID and view type
  const iframeUrl = `https://drive.google.com/embeddedfolderview?id=${embed.id}#${embed.view || 'grid'}`;

  return (
    <Box mb={4} shadow="md" p={4} rounded="md" bg={bgColor} borderWidth="1px" borderColor={borderColor}>
      {/* Header Info */}
      {embed.name && (
        <Box mb={4}>
          <Heading size="lg">{embed.name}</Heading>
          {embed.description && (
            <>

              <Link
                href={`https://drive.google.com/drive/folders/${embed.id}`}
                target="_blank"
                rel="noopener noreferrer"
                mt={2}
                fontSize="sm"
                color="blue.500"
                _hover={{ textDecoration: 'underline', color: 'blue.600' }}
              >
                {embed.description} here →
              </Link>
            </>
          )}

        </Box>
      )}

      {/* Iframe Container */}
      <Box
        w="100%"
        h={embed.height || '600px'}
        rounded="md"
      >
        <iframe
          src={iframeUrl}
          title={embed.name || 'Embedded Content'}
          allowFullScreen
          allow={embed.allow || 'fullscreen'}
          width="100%"
          height="100%"
          style={{
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px',
            border: 'none'
          }}
        />
      </Box>
    </Box>
  );
}

export default IframeEmbed;
